var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _vm.checkPermi(["platform:integral:product:page"])
        ? _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: 0 },
              },
            },
            [
              _c(
                "div",
                { staticClass: "padding-add" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-position": "right",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品搜索：" } },
                        [
                          _c("el-input", {
                            staticClass: "form_content_width",
                            attrs: {
                              placeholder: "请输入商品名称关键字",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSeachList($event)
                              },
                            },
                            model: {
                              value: _vm.keywords,
                              callback: function ($$v) {
                                _vm.keywords =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "keywords",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建日期：" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth",
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd",
                              size: "small",
                              type: "daterange",
                              placement: "bottom-end",
                              placeholder: "自定义时间",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.onchangeTime },
                            model: {
                              value: _vm.timeVal,
                              callback: function ($$v) {
                                _vm.timeVal = $$v
                              },
                              expression: "timeVal",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleSeachList },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _vm.checkPermi(["platform:integral:product:page"])
            ? _c(
                "div",
                { ref: "headerBox", staticClass: "clearfix" },
                [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "list-tabs mb5",
                      on: { "tab-click": _vm.handleSeachList },
                      model: {
                        value: _vm.tableFrom.isShow,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "isShow", $$v)
                        },
                        expression: "tableFrom.isShow",
                      },
                    },
                    _vm._l(_vm.headeNum, function (item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        attrs: {
                          label: item.name + "(" + item.count + ")",
                          name: item.type,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: [
                    "platform:integral:product:save",
                    "platform:product:marketing:search:page",
                  ],
                  expression:
                    "['platform:integral:product:save', 'platform:product:marketing:search:page']",
                },
              ],
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.handleQuickAdd("isAdd")
                },
              },
            },
            [_vm._v("快速添加")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": true,
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品图", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview line-heightOne" },
                          [
                            _c("el-image", {
                              attrs: {
                                src: scope.row.image,
                                "preview-src-list": [scope.row.image],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "商品名称",
                  "min-width": "200",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "redeemIntegral",
                  label: "兑换积分",
                  "min-width": "90",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "price",
                  label: "兑换金额（元）",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "redPacket",
                  label: "红包抵扣（元）",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "sales", label: "已兑换数", "min-width": "90" },
              }),
              _c("el-table-column", {
                attrs: { prop: "stock", label: "剩余库存", "min-width": "90" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "virtualStock",
                  label: "虚拟库存",
                  "min-width": "90",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", label: "排序", "min-width": "90" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "80", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.checkPermi([
                          "platform:integral:product:update:show",
                        ])
                          ? _c("el-switch", {
                              attrs: {
                                "active-value": true,
                                "inactive-value": false,
                                "active-text": "上架",
                                "inactive-text": "下架",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onchangeIsShow(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.isShow,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "isShow", $$v)
                                },
                                expression: "scope.row.isShow",
                              },
                            })
                          : _c("div", [
                              _vm._v(
                                _vm._s(scope.row.isShow ? "上架" : "下架")
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { width: "190", fixed: "right", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.checkPermi(["platform:integral:product:detail"])
                          ? [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleView(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("详情")]
                              ),
                            ]
                          : _vm._e(),
                        _vm.checkPermi(["platform:integral:product:update"])
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEdit(scope.row, "edit")
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                            ]
                          : _vm._e(),
                        _vm.checkPermi(["platform:integral:product:save"])
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEdit(scope.row, "copy")
                                    },
                                  },
                                },
                                [_vm._v("复制")]
                              ),
                            ]
                          : _vm._e(),
                        _vm.checkPermi(["platform:integral:product:delete"])
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(
                                        scope.row.id,
                                        _vm.tableFrom.type
                                      )
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("info-from", {
        ref: "infoFrom",
        attrs: {
          componentKey: _vm.componentKey,
          "is-atud": false,
          "is-show": _vm.isShow,
          productId: _vm.productId,
          fromType: "pointsMall",
          dialogVisibleInfoData: _vm.dialogVisibleInfo,
        },
        on: { onCloseInfo: _vm.onCloseInfo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }